import axios from 'axios';
import AuthService from './AuthService';

const BASE = process.env.REACT_APP_API_URL;

const hdr = () => ({ headers: { Authorization: `Bearer ${AuthService.getToken()}` } });

const WorkspaceSettingsService = {
  getAttendanceGeoFence: (clientId) =>
    axios.get(`${BASE}/Client/GetAttendanceGeoFence/${clientId}`, hdr()).then((r) => r.data),

  updateAttendanceGeoFence: (clientId, dto) =>
    axios.put(`${BASE}/Client/UpdateAttendanceGeoFence/${clientId}`, dto, hdr()).then((r) => r.data),

  getMetaLeadAutoAssignSettings: (clientId) =>
    axios.get(`${BASE}/Client/GetMetaLeadAutoAssignSettings/${clientId}`, hdr()).then((r) => r.data),

  updateMetaLeadAutoAssignSettings: (clientId, dto) =>
    axios.put(`${BASE}/Client/UpdateMetaLeadAutoAssignSettings/${clientId}`, dto, hdr()).then((r) => r.data),

  getLeadInactivityReassignSettings: (clientId) =>
    axios.get(`${BASE}/Client/GetLeadInactivityReassignSettings/${clientId}`, hdr()).then((r) => r.data),

  updateLeadInactivityReassignSettings: (clientId, dto) =>
    axios.put(`${BASE}/Client/UpdateLeadInactivityReassignSettings/${clientId}`, dto, hdr()).then((r) => r.data),
};

export default WorkspaceSettingsService;
